namespace TabAurous.Retail {
    export namespace POSOrderItemsService {
        export const baseUrl = 'Retail/OrderItems';

        export declare function Create(request: Serenity.SaveRequest<POSOrderItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSOrderItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function OrderProcessingList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ValidateQuotation(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/OrderItems/Create",
            Update = "Retail/OrderItems/Update",
            Delete = "Retail/OrderItems/Delete",
            Retrieve = "Retail/OrderItems/Retrieve",
            List = "Retail/OrderItems/List",
            CustomList = "Retail/OrderItems/CustomList",
            OrderProcessingList = "Retail/OrderItems/OrderProcessingList",
            ValidateQuotation = "Retail/OrderItems/ValidateQuotation"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'OrderProcessingList', 
            'ValidateQuotation'
        ].forEach(x => {
            (<any>POSOrderItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
